import {
    Button,
    Container,
    IconButton,
    InputAdornment,
    Modal,
    TextField,
    ThemeProvider,
    Typography,
    createTheme,
} from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import MessageModal from "./MessageModal";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Visibility } from "@mui/icons-material";
import { URL, origin } from "../config";

export default function ChangePassword(props) {
    const [error, setError] = React.useState("");
    const [alert, setAlert] = React.useState(false);
    const [newPass, setNewPass] = React.useState("");
    const [newPassConfirm, setNewPassConfirm] = React.useState("");
    const [oldPass, setOldPass] = React.useState("");
    const [showOldPass, setShowOldPass] = React.useState(false);
    const [showNewPass, setShowNewPass] = React.useState(false);
    const [showNewPassConfirm, setShownewPassConfirm] = React.useState(false);

    const theme = createTheme({
        secondary: "#EEEEEE",
        typography: {
            fontFamily: ["Tilt Warp", "sans-serif"].join(","),
        },
    });
    const handleSubmit = (e) => {
        e.preventDefault();
        const data = {
            username: localStorage.getItem("name"),
            password: oldPass,
        };

        fetch(`${URL}/login/`, {
            method: "POST",
            mode: "cors",
            credentials: "include",
            headers: {
                "content-type": "application/json",
                Origin: `${origin}`,
            },
            body: JSON.stringify(data),
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                if (data.error) {
                    setError(data.error.message);
                    throw new Error(data.error.message);
                }
            })
            .then(() => {
                //checking if the password is correct for the account

                if (newPass === newPassConfirm) {
                    const data = {
                        password: newPass,
                    };
                    fetch(`http://localhost:5001/update/password`, {
                        method: "POST",
                        mode: "cors",
                        credentials: "include",
                        headers: {
                            "content-type": "application/json",
                            Origin: `http://localhost:3000`,
                        },
                        body: JSON.stringify(data),
                    })
                        .then((response) => {
                            return response.json();
                        })
                        .then((data) => {
                            if (data.error) {
                                setError(data.error.message);
                                throw new Error(data.error.message);
                            }
                        })
                        .then(() => {
                            //update the password if new passwords match
                            setAlert(true);
                            setError("");
                        })
                        .catch(() => {
                            console.error((err) => console.log(err));
                        });
                } else {
                    setError("new passwords do not match");
                }
            })
            .catch(() => {
                console.error((err) => console.log(err));
            });
    };

    const closeAlert = () => {
        setAlert(false);
    };

    const handleShowOldPass = () => {
        setShowOldPass((show) => !show);
    };
    const handleShowNewPass = () => {
        setShowNewPass((show) => !show);
    };
    const handleShowNewPassConfirm = () => {
        setShownewPassConfirm((show) => !show);
    };

    const style = {
        backgroundColor: "whitesmoke",
        top: "50%",
        left: "50%",
        position: "absolute",
        transform: "translate(-50%, -50%)",
        width: "60%",
        boxShadow: 24,
        borderRadius: 2,
        minHeight: "30%",
        "@media (max-width: 75em)": {
            display: "flex",
            flexDirection: "column",
            width: "80%",
            maxHeight: "90vh",
            overflow: "auto",
        },
    };

    return (
        <>
            <ThemeProvider theme={theme}>
                <Modal open={props.open} onClose={props.onClose}>
                    <Container sx={{ display: "flex" }}>
                        <Box sx={style} display="flex" flexDirection="row">
                            <Box
                                sx={{
                                    backgroundColor: "#EEEEEE",
                                    minWidth: "60%",
                                    borderRadius: "8px 0 0 8px",
                                    "@media (max-width: 75em)": {
                                        borderRadius: "0",
                                    },
                                }}
                                display="flex"
                                justifyContent="center"
                                flexDirection="column"
                            >
                                <Typography variant="h6" textAlign="center">
                                    Change your password
                                </Typography>
                                <Box color="#5d5c5b" sx={{ m: 1, p: 3 }}>
                                    <Typography sx={{ fontWeight: "bold" }}>
                                        Password requirements
                                    </Typography>
                                    <Typography>
                                        {" "}
                                        - Password must be at least 6 characters
                                    </Typography>
                                    <Typography
                                        sx={{ fontWeight: "bold", my: 1 }}
                                    >
                                        Password recommendation for noobs
                                    </Typography>
                                    <Typography>
                                        - Password should contain numbers and
                                        special character/s
                                    </Typography>
                                    <Typography>
                                        - Should not contain easily guessed
                                        words
                                    </Typography>
                                    <Typography>
                                        - Really should be using a password
                                        manager{" "}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                justifyContent="center"
                                sx={{ minWidth: "40%" }}
                            >
                                <TextField
                                    error={error ? true : false}
                                    value={oldPass}
                                    onChange={(e) => setOldPass(e.target.value)}
                                    size="small"
                                    type={showOldPass ? "text" : "password"}
                                    label="old password"
                                    sx={{ width: "90%", my: 2 }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    edge="end"
                                                    onClick={handleShowOldPass}
                                                >
                                                    {showOldPass ? (
                                                        <VisibilityOffIcon />
                                                    ) : (
                                                        <VisibilityIcon />
                                                    )}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                ></TextField>
                                <TextField
                                    error={error ? true : false}
                                    value={newPass}
                                    onChange={(e) => setNewPass(e.target.value)}
                                    size="small"
                                    type={showNewPass ? "text" : "password"}
                                    label="new password"
                                    sx={{ width: "90%", my: 2 }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    edge="end"
                                                    onClick={handleShowNewPass}
                                                >
                                                    {showNewPass ? (
                                                        <VisibilityOffIcon />
                                                    ) : (
                                                        <VisibilityIcon />
                                                    )}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                ></TextField>
                                <TextField
                                    error={error ? true : false}
                                    value={newPassConfirm}
                                    onChange={(e) =>
                                        setNewPassConfirm(e.target.value)
                                    }
                                    helperText={error}
                                    size="small"
                                    type={
                                        showNewPassConfirm ? "text" : "password"
                                    }
                                    label="confirm password"
                                    sx={{ width: "90%", my: 2 }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    edge="end"
                                                    onClick={
                                                        handleShowNewPassConfirm
                                                    }
                                                >
                                                    {showNewPassConfirm ? (
                                                        <VisibilityOffIcon />
                                                    ) : (
                                                        <Visibility />
                                                    )}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                ></TextField>
                                <Button
                                    disabled={
                                        newPass.length < 6 ||
                                        newPassConfirm.length < 6
                                            ? true
                                            : false
                                    }
                                    variant="outlined"
                                    sx={{ width: "50%", my: 1 }}
                                    onClick={handleSubmit}
                                >
                                    Submit
                                </Button>
                            </Box>
                        </Box>
                    </Container>
                </Modal>
                <MessageModal
                    severity="success"
                    title="success"
                    open={alert}
                    onClose={closeAlert}
                >
                    password updated
                </MessageModal>
            </ThemeProvider>
        </>
    );
}
